"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SkeletonField = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _useRandom = require("@oberoninternal/travelbase-ds/hooks/useRandom");
var _react = _interopRequireWildcard(require("react"));
var _reactLoadingSkeleton = _interopRequireDefault(require("react-loading-skeleton"));
var _Heading = _interopRequireDefault(require("./designsystem/Heading"));
var _Stack = _interopRequireDefault(require("./Stack"));
const _excluded = ["range", "spacing", "skeletonHeight"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const SkeletonField = ({
  skeletonHeight
}) => {
  const elementWidth = (0, _useRandom.useRandom)(50, 100);
  const renderHeading = (0, _useRandom.useRandom)(1, 4) === 1;
  const elementHeight = (0, _useRandom.useRandom)(skeletonHeight?.min ?? 0, skeletonHeight?.max ?? 0);
  return __jsx(_react.default.Fragment, null, renderHeading && __jsx(_Heading.default, null, __jsx(_reactLoadingSkeleton.default, {
    height: "2rem"
  })), __jsx(_reactLoadingSkeleton.default, {
    width: `${Math.round(elementWidth)}%`,
    height: elementHeight !== 0 ? elementHeight : undefined
  }));
};
exports.SkeletonField = SkeletonField;
const rangeConfig = {
  min: 5,
  max: 8
};
const Loading = _ref => {
  let {
      range = rangeConfig,
      spacing = 5,
      skeletonHeight
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const random = (0, _useRandom.useRandom)(range.min, range.max);
  return __jsx(_Stack.default, (0, _extends2.default)({
    spacing: spacing,
    width: 1
  }, props), new Array(random).fill(null).map((_, i) => __jsx(SkeletonField, {
    key: i,
    skeletonHeight: skeletonHeight
  })));
};
var _default = exports.default = /*#__PURE__*/(0, _react.memo)(Loading);